module.exports = __webpack_public_path__ + "assets/img/csfw_icon.1f69831f.png";